import React from 'react'
import {Link} from 'gatsby'

const Header = () =>{
    return (
        // Can't figure out how to remove the red line under the Links
        <div className="flex items-center justify-end py-4 mb-8 mt-0 border-none no-underline">
            <Link className="hover:text-gray-700 font-roboto text-sm text-tufan-red px-3 no-underline cursor-pointer border-none" to="/">Tufan</Link>
            <Link className="hover:text-gray-700 font-roboto text-sm text-tufan-red px-3 no-underline cursor-pointer border-none" to="/#Howitworks">How It Works</Link>
            <Link className="hover:text-gray-700 font-roboto text-sm text-tufan-red px-3 no-underline cursor-pointer border-none" to="/#Features">Features</Link>
            <Link className="hover:text-gray-700 font-roboto text-sm text-tufan-red px-3 no-underline cursor-pointer border-none" to="/#Pricing">Pricing</Link>
            <Link className="hover:text-gray-700 font-roboto text-sm text-tufan-red px-3 no-underline cursor-pointer border-none" to="/blogindex">Blog</Link>
        </div>
    )
}

export default Header